import { render, staticRenderFns } from "./CheckBillsTable.vue?vue&type=template&id=6b28f5c0&scoped=true"
import script from "./CheckBillsTable.vue?vue&type=script&lang=js"
export * from "./CheckBillsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28f5c0",
  null
  
)

export default component.exports